import React from 'react';
import PropTypes from 'prop-types';
import { range } from 'lodash-es';
import { Translate } from 'react-localize-redux';
import styles from './pagination.module.css';

const Pagination = ({
  navFunction, totalPages, number, first, last
}) => {
  const page = number;
  const smallest = Math.max(page - 2, 1);
  const largest = Math.min(page + 2, totalPages - 1);

  const moreIndicator = <div className={styles.more}>⋯</div>;

  const moreBefore = (page > 2) ? moreIndicator : '';
  const moreAfter = (largest < totalPages - 1) ? moreIndicator : '';

  const createButton = (pageNumber) => (
    <button
      type="button"
      key={pageNumber}
      className={`button ${styles.pageButton}`}
      onClick={() => navFunction(pageNumber)}
      disabled={page === pageNumber}
    >
      {pageNumber + 1}
    </button>
  );

  const buttons = (smallest < largest) ? range(smallest, largest).map(createButton) : '';

  const prevPageButton = !first ? (
    <button
      type="button"
      className="button--action icon--arrow-left"
      onClick={() => navFunction(page - 1)}
    >
      <Translate id="common.previous" />
    </button>
  ) : '';

  const nextPageButton = !last ? (
    <button
      type="button"
      className="button--action icon--arrow-right"
      onClick={() => navFunction(page + 1)}
    >
      <Translate id="common.next" />
    </button>
  ) : '';

  const lastPageButton = (totalPages > 1) ? createButton(totalPages - 1) : '';
  const firstPageButton = createButton(0);

  return (
    <nav className={styles.navigation}>
      {prevPageButton}
      {firstPageButton}
      {moreBefore}
      {buttons}
      {moreAfter}
      {lastPageButton}
      {nextPageButton}
    </nav>
  );
};

const { func, bool, number } = PropTypes;

Pagination.propTypes = {
  navFunction: func.isRequired,
  first: bool.isRequired,
  last: bool.isRequired,
  number: number.isRequired,
  totalPages: number.isRequired
};

export default Pagination;
